import {createContext,useContext} from 'react';

const AuthContext=createContext(null);
const UseAuthContext=()=>useContext(AuthContext);

export {AuthContext,UseAuthContext};